import apiService from './apiService';

const commissionService = {
  // Jutalékcsoportok lekérdezése
  getCommissionGroups: async () => {
    try {
      const response = await apiService.get('/commissions/groups');
      return response; // MÓDOSÍTVA: A teljes válasz objektumot adjuk vissza
    } catch (error) {
      console.error('Error fetching commission groups:', error);
      throw error;
    }
  },

  // Új jutalékcsoport létrehozása
  createCommissionGroup: async (groupData) => {
    try {
      const response = await apiService.post('/commissions/groups', groupData);
      return response; // MÓDOSÍTVA: A teljes válasz objektumot adjuk vissza
    } catch (error) {
      console.error('Error creating commission group:', error);
      throw error;
    }
  },

  // Jutalékcsoport frissítése
  updateCommissionGroup: async (id, groupData) => {
    try {
      const response = await apiService.put(`/commissions/groups/${id}`, groupData);
      return response; // MÓDOSÍTVA: A teljes válasz objektumot adjuk vissza
    } catch (error) {
      console.error('Error updating commission group:', error);
      throw error;
    }
  },

  // Jutalékcsoport törlése
  deleteCommissionGroup: async (id) => {
    try {
      const response = await apiService.delete(`/commissions/groups/${id}`);
      return response; // MÓDOSÍTVA: A teljes válasz objektumot adjuk vissza
    } catch (error) {
      console.error('Error deleting commission group:', error);
      throw error;
    }
  },

  // Jutalékos foglalások lekérdezése
  getCommissionedBookings: async (page = 1, limit = 10, filters = {}) => {
    try {
      const query = new URLSearchParams({
        page,
        limit,
        ...filters,
      }).toString();
      const response = await apiService.get(`/commissions/bookings?${query}`);
      return response; // MÓDOSÍTVA: A teljes válasz objektumot adjuk vissza
    } catch (error) {
      console.error('Error fetching commissioned bookings:', error);
      throw error;
    }
  },

  // Jutalék kifizetési státusz frissítése
  updateCommissionPayoutStatus: async (bookingId, newStatus) => {
    try {
      const response = await apiService.put(`/commissions/bookings/${bookingId}/payout-status`, { status: newStatus });
      return response;
    } catch (error) {
      console.error(`Error updating commission payout status for booking ${bookingId}:`, error);
      throw error;
    }
  },
};


export default commissionService;